import type { DemoDataReducerState } from './types';

export const demoDataSelector = (state: DemoDataReducerState) => state.baus.demoData;
export const getEventUploaderApiIsLoading = (state: DemoDataReducerState) =>
  demoDataSelector(state).isLoading;
